import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('helpdesk_language');
    return savedLanguage || 'tr';
  });

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('helpdesk_language', newLanguage);
  };

  useEffect(() => {
    // Set document lang attribute
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{
      language,
      changeLanguage,
      isEnglish: language === 'en',
      isTurkish: language === 'tr'
    }}>
      {children}
    </LanguageContext.Provider>
  );
};